import { useQuery } from "@tanstack/react-query";
import { PortfolioKeys } from "web_myplann/Api/Portfolio/portfolioKeys";
import { getPropertyIdV2 } from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

export const usePropertyQuery = (id?: number, enabled = true) => {
	return useQuery({
		queryKey: PortfolioKeys.propertyDetail(id ?? null),
		queryFn: processResponse(() => getPropertyIdV2(id!), {
			throwOn404: true,
			skipToastFor: [404],
		}),
		enabled: enabled && Boolean(id),
	});
};
